import { Card } from 'antd';

const DashboardTile = ({ title, className,children }) => {

  return (
    <Card
      title={<div className="text-center font-bold text-lg py-3">{title}</div>}
      bodyStyle={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 24px' }}
      className={className}
    >
      {children}
    </Card>
  );
};

export default DashboardTile;
